import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AccesoUsuario } from '../models/acceso-usuario';
import { utils } from '../utils/utils';

@Injectable({
  providedIn: 'root'
})
export class AccesoGuardService {
  Acceso: Array<any>;
  public _utils: utils;

  constructor(private router: Router, private _http: HttpClient) { 
    this._utils = new utils();
  } 

  //Validación de usuario al navegar una URL
  async canActivate(route: ActivatedRouteSnapshot) {
    let idUsuario = Number.parseInt(sessionStorage.getItem('idUsuario'));
    this.Acceso = await this.obtenerAccesos(idUsuario);

    if(!this.tieneAcceso(route.data.key))
      this.router.navigate(['/pages']);
    else
      return this.tieneAcceso(route.data.key);
  }


  // Verifica si el usuario tiene el permiso para acceder a esta funcionalidad
  tieneAcceso = (codigo): boolean => this.Acceso.find(a => a.codigo == codigo) ? true : false;


  // Obtiene la lista de accesos a los que cuenta el usuario
  async obtenerAccesos(idUsuario: number): Promise<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Accept': 'application/json, text/javascript, /;'});

    let accesoUsuario: AccesoUsuario = {
      IdUsuario: idUsuario
    };
    let json = JSON.stringify(accesoUsuario);

    return new Promise((resolve, reject) => {
      this._http.post(`${this._utils.url}api/Usuario/GetSeguridadUsuarioAcceso`, json, {headers: headers }).pipe(
        map((res: any) => JSON.parse(res)
      )).subscribe((success) => resolve(success));
    });
  }

}
